import React from 'react';
import { bool, object, func } from 'prop-types';
import { get } from 'lodash';
import { Drawer } from '../../../../components/common';
import { withFirebase } from '../../../../hoc';
import AuditOrderContainer from './components/AuditOrderContainer';
import AuditOrderContainerLegacy from './components/variants/AuditOrderContainerLegacy';
import { DrawerTitleLegacy } from './components/variants/DrawerTitleLegacy';
import { useAuditState } from './hooks/useAuditState';
import { useAuditNewDesignFlag } from '../../hooks/useAuditNewDesignFlag';

const AuditOrderDrawer = ({ visible, selectedOrder, userInfo, onClose, refetch, isAudit, firebase }) => {
    const {
        isBipickingGroup,
        orderId,
    } = useAuditState(selectedOrder);

    const storeId = get(selectedOrder, 'salesChannel.id');
    const isNewDesignEnabled = useAuditNewDesignFlag(firebase, storeId);
    const effectiveIsAudit = isAudit && isNewDesignEnabled;

    return (
        <Drawer
            minWidth='80%'
            className='audit-monitor'
            title={!effectiveIsAudit ? <DrawerTitleLegacy isBipickingGroup={isBipickingGroup} orderId={orderId} /> : undefined}
            closable
            visible={visible}
            onClose={onClose}
        >
            {(visible && selectedOrder) && (effectiveIsAudit ? (
                <AuditOrderContainer
                    refetch={refetch}
                    userInfo={userInfo}
                    onClose={onClose}
                    selectedOrder={selectedOrder}
                />
            ) : (
                <AuditOrderContainerLegacy
                    refetch={refetch}
                    userInfo={userInfo}
                    onClose={onClose}
                    selectedOrder={selectedOrder}
                />
            ))}
        </Drawer>
    );
};

AuditOrderDrawer.propTypes = {
    visible: bool.isRequired,
    selectedOrder: object,
    userInfo: object,
    onClose: func.isRequired,
    refetch: func,
    isAudit: bool,
    firebase: object
};

export default withFirebase(AuditOrderDrawer);
